import { Button } from "primereact/button";
import { QrCodeUrl } from "../hooks/useQrCodes";

export function ActionsCell({
    row,
    onAssign,
    onPreview,
    onUnassign,
}: {
    row: QrCodeUrl;
    onAssign: (url: string) => void;
    onPreview: (url: string) => void;
    onUnassign: (url: string) => void;
}) {
    const hasTarget = row.target != null && row.target !== "";

    return (
        <div className="flex gap-2">
            {hasTarget ? (
                <Button
                    icon="pi pi-times"
                    rounded
                    onClick={() => onUnassign(row.qrCodeUrl)}
                />
            ) : (
                <Button
                    icon="pi pi-link"
                    rounded
                    onClick={() => onAssign(row.qrCodeUrl)}
                />
            )}
            <Button
                icon="pi pi-external-link"
                disabled={!hasTarget}
                rounded
                onClick={() => window.open(row.qrCodeUrl, "_blank")}
            />
            <Button icon="pi pi-qrcode" rounded onClick={() => onPreview(row.qrCodeUrl)} />
        </div>
    );
}